import React, { useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
// import "../PagesStyles/AdminMasters.css";
import { Box, Button } from "@mui/material";
import AlertMessage from "../../Other Functions/AlertMessage";
import { Icon } from "@iconify/react";
import style from "../LatestPages/AddNewCustomer.module.css";

export function DaimondAttributeNew() {
  const [showError, setShowError] = useState(false);
  const [messageToShow, setMessageToShow] = useState("");
  const [messageType, setMessageType] = useState("error");
  const [newCs, setNewCs] = useState({ LastName: "" });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setNewCs({ ...newCs, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError && (
          <AlertMessage message={messageToShow} type={messageType} />
        )}
        <AdminBreadCrump
          title={"Add Diamond"}
          companyName={"Loyalstring"}
          module={"Masters"}
          page={"Add Diamond Attributes"}
        />
        <div style={{padding: '0px 16px'}} className="adminAddCategoryMainBox">
          <div className="adminAddCategoryInnerBox">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              {/* <h2
                style={{
                  margin: 0,
                  fontSize: "16px",
                 fontWeight: '600',
                 fontFamilyL: 'Inter'
                }}
              >
                Add New Diamond Attribute
              </h2> */}

              <h2
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                      className={style.adminCategoryHeading}
                      id="adminInvoiceAddedCustomerEdit"
                    >
                          Add New Diamond Attribute
                    </h2>
            </Box>
            <form>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "20px",
                }}
              >
                <div
                  className="formRow"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "20px",
                    gap: '10px'
                  }}
                >
                  <label
                   
                  >
                    Diamond Attribute <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <select
                    name="DiamondAttribute"
                    required
                    style={{
                      flex: "1", // Input takes remaining space
                      padding: "10px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  >
                    <option value="">Select An Option</option>
                    <option value="DiamondClarity">Diamond Clarity</option>
                    <option value="DiamondColour">Diamond Colour</option>
                    <option value="DiamondCut">Diamond Cut</option>
                    <option value="DiamondShape">Diamond Shape</option>
                    <option value="DiamondSettingType">Setting Type</option>
                  </select>
                </div>

                <div
                  className="formRow"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "20px",
                    gap: '10px'
                  }}
                >
                  <label
                   
                  >
                    Diamond Value <sup style={{ color: "red" }}>*</sup>
                  </label>
                  <input
                    type="text"
                    name="LastName"
                    value=""
                    style={{
                      flex: "1", // Input takes remaining space
                      padding: "10px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </Box>
              <Box
                sx={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                >
                  <Icon icon="ic:round-check" width="24" height="24" />
                  Submit
                </Button>
              </Box>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
